import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {ITmtErpReportItem} from '../interfaces/tmt-erp-panel.interface';
import {TmtErpPanelFilterService} from './tmt-erp-panel-filter.service';
import moment from 'moment';
import { Sort } from '@angular/material/sort';

@Injectable({
  providedIn: 'root'
})
export class TmtErpReportGridService implements GridGetService<ITmtErpReportItem> {
  private readonly baseUrl = 'tmt/sales-orders/erp-report';
  private readonly http = inject(HttpClient);
  private readonly filterService = inject(TmtErpPanelFilterService);

  getItems({page, sort}: GridServiceParams): Observable<GridServiceResponse<ITmtErpReportItem>> {
    const filters = this.filterService.filtersValue();

    const params: Record<string, string | number | boolean | string[] | number[]> = {
      pageSize: page?.pageSize || 25,
      pageNumber: (page?.pageIndex || 0) + 1,
      propertyName: this.mapSortPropertyName(sort),
      orderKey: sort?.direction || '',
      salesOrderId: filters?.SalesOrderId ?? '',
      tripReference: filters?.TripReference ?? '',
      erpOrderNumber: filters?.ErpOrderNumber ?? '',
      clientName: filters?.ClientName ?? '',
      createdDateFrom: filters?.CreatedDateFrom ? moment(filters.CreatedDateFrom).format('YYYY-MM-DD') : '',
      createdDateTo: filters?.CreatedDateTo ? moment(filters.CreatedDateTo).format('YYYY-MM-DD') : '',
      erpSentDateFrom: filters?.ErpSentDateFrom ? moment(filters.ErpSentDateFrom).format('YYYY-MM-DD') : '',
      erpSentDateTo: filters?.ErpSentDateTo ? moment(filters.ErpSentDateTo).format('YYYY-MM-DD') : '',
      erpResponseDateFrom: filters?.ErpResponseDateFrom ? moment(filters.ErpResponseDateFrom).format('YYYY-MM-DD') : '',
      erpResponseDateTo: filters?.ErpResponseDateTo ? moment(filters.ErpResponseDateTo).format('YYYY-MM-DD') : '',
      ...(filters?.IsFailed !== null && filters?.IsFailed !== undefined ? {isFailed: filters.IsFailed} : {}),
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<ITmtErpReportItem>>(this.baseUrl, {params: {...params}})
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.message || 'Server error');
      }));
  }

  /**
   * Sorting happens over SalesOrderErpReportView, so columns the response DTO renames have to be
   * translated back to the view's own property names or the server ignores the sort entirely.
   */
  private mapSortPropertyName(sort?: Partial<Sort>): string {
    if (!sort?.active) return '';

    const propertyNameMap: { [key: string]: string } = {
      'tmtSalesOrderId': 'id',
    };

    return propertyNameMap[sort.active] || sort.active;
  }
}
